<script>
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
    };
  },
  computed: {
    loggingIn() {
      return this.$store.getters["authentication/loggingIn"];
    },
  },
  created() {
    // reset login status
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      const { username, password } = this;
      if (username && password) {
        this.$store.dispatch("authentication/login", { username, password });
      }
    },
  },
};
</script>

<template>
  <section id="view-login" class="view">
    <div class="view__body">
      <div class="container">
        <div class="wrapper">
          <img class="logo" src="../assets/img/rm.svg" alt="" />
          <h1 class="title">Log in</h1>
          <form @submit.prevent="handleSubmit" autocomplete="off">
            <div class="field">
              <input
                id="user_login"
                class="input input-is-fat"
                type="email"
                name="log"
                placeholder="Email"
                autocomplete="off"
                v-model="username"
                :disabled="loggingIn"
              />
              <div v-show="submitted && !username" class="invalid-feedback">
                Username is required
              </div>
            </div>
            <div class="field">
              <input
                id="user_pass"
                class="input input-is-fat"
                type="password"
                name="pwd"
                placeholder="Password"
                autocomplete="off"
                v-model="password"
                :disabled="loggingIn"
              />
              <div v-show="submitted && !password" class="invalid-feedback">
                Password is required
              </div>
            </div>
            <button
              @click="handleSubmit"
              class="button is-primary is-medium is-rounded"
              :class="{ 'is-loading': loggingIn }"
              :disabled="loggingIn"
            >
              Log in
            </button>
          </form>
        </div>
      </div>
      <!-- <p class="poweredBy">Powered by Clickable</p> -->
    </div>
  </section>
</template>

<style lang="scss" scoped>
img.logo {
  max-width: 8rem;
  margin-bottom: 2rem;
}
.container {
  width: 100%;
  display: flex;
  align-items: center;
  .wrapper {
    width: 100%;
  }
}
.view {
  text-align: center;

  a:not(button) {
    text-decoration: underline;
  }

  a {
    text-decoration: underline;
  }

  form {
    width: 100%;
    max-width: 28rem;
    margin: 0 auto;
    margin-bottom: 2rem;

    .button {
      font-weight: bold;
      padding: 0.5rem 2rem;
      height: auto;
    }
  }
}
</style>
